module.exports = __webpack_public_path__ + "static/media/1area.7bb94309.jpg";